import React from 'react';

/**
 * @prop {bool} rounded
 * @prop {string} color
 * @prop {number} speed
 * @prop {number} stroke
 * @prop {number} value
 * @prop {number} max
 * @prop {number} size
 */

class RadialProgress extends React.Component {
  constructor(props) {
    super(props);
    this.radialRenderTimer = null;
    this.state = {
      value: this.props.value,
    };
  }

  componentDidMount() {
    this.initStyles(() => {
      this.refs.bar.style.opacity = 1;
      this.draw();
    });
  }

  componentWillUnmount() {
    window.clearTimeout(this.radialRenderTimer);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState(
        {
          value: nextProps.value,
        },
        () => {
          this.draw();
        },
      );
    }
  }

  getStrokeWidth() {
    return this.props.stroke || 6;
  }

  getSize() {
    return this.props.size || 48;
  }

  getCenter() {
    return this.getSize() / 2;
  }

  getRadius() {
    return (this.getSize() - this.getStrokeWidth()) / 2;
  }

  getCircumference() {
    return Math.PI * this.getRadius() * 2;
  }

  initTransition(speed = this.props.speed || 400) {
    this.refs.bar.style.transition = `all ${speed}ms cubic-bezier(0.175, 0.885, 0.32, 1.275)`;
  }

  initStyles(callback) {
    this.initTransition();
    this.refs.bar.style.strokeDashoffset = this.getCircumference();
    this.refs.bar.style.strokeDasharray = this.getCircumference();
    this.refs.bar.style.opacity = 0;
    this.radialRenderTimer = setTimeout(() => callback(), 300);
  }

  draw() {
    const value = (this.state.value / this.props.max) * 100;
    const offset = (this.getCircumference() * (100 - value)) / 100;
    this.refs.bar.style.strokeDashoffset = offset;
  }

  render() {
    const companyColor = document.body.getAttribute('data-custom-color')
      ? document.body.getAttribute('data-custom-color')
      : '#FFCF3F';

    return (
      <div className="NewRadialProgressBar CustomColor--color">
        <span className="NewRadialProgressBar-value">{this.props.value}</span>
        <svg
          width={this.getSize()}
          height={this.getSize()}
          viewBox={`0 0 ${this.getSize()} ${this.getSize()}`}
          className="NewRadialProgressBar-svg"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            r={this.getRadius()}
            cx={this.getCenter()}
            cy={this.getCenter()}
            strokeWidth={this.getStrokeWidth()}
            stroke="rgba(0,0,0,0.05)"
            fill="transparent"
            className="NewRadialProgressBar-background"
          />
          <circle
            r={this.getRadius()}
            cx={this.getCenter()}
            cy={this.getCenter()}
            stroke={this.props.color ? this.props.color : companyColor}
            strokeWidth={this.getStrokeWidth()}
            strokeLinecap={this.props.rounded ? 'round' : ''}
            fill="transparent"
            transform={`rotate(270 ${this.getCenter()} ${this.getCenter()})`}
            className="NewRadialProgressBar-bar"
            ref="bar"
          />
        </svg>
      </div>
    );
  }
}

export default RadialProgress;
